import FrequencyTrendLimitLogFactory from "../../factories/FrequencyTrendLimitLogFactory";
import FrequencyTrendLimitLogGetters from "./FrequencyTrendLimitLogGetters";
import FrequencyTrendLimitLogActions from "./FrequencyTrendLimitLogActions";
import FrequencyTrendLimitLogMutations from "./FrequencyTrendLimitLogMutations";

const state = FrequencyTrendLimitLogFactory.StateEmpty();

const { getters } = FrequencyTrendLimitLogGetters;

const { actions } = FrequencyTrendLimitLogActions;

const { mutations } = FrequencyTrendLimitLogMutations;

const namespaced = true;

export default {
	state,
	namespaced,
	actions,
	mutations,
	getters
};